<span [class]="dataType" [appTooltip]="tooltip">{{ getFormattedValue() }}</span>
